export const EsCodeGridPluginSettings: IPluginSettings = {
    name: 'Код ЕС',
    mnemocode: 'es_code_plugin',
    permission: 'EsCode',
    columns: [
    ]
}
